/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Settings_TitleInputs */

const en_simple_settings_title = /** @type {(inputs: Simple_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simple mode`)
};

const id_simple_settings_title = /** @type {(inputs: Simple_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mode sederhana`)
};

/**
* | output |
* | --- |
* | "Simple mode" |
*
* @param {Simple_Settings_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_settings_title = /** @type {((inputs?: Simple_Settings_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Settings_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_settings_title(inputs)
	return en_simple_settings_title(inputs)
});